import './fatboys/style';
import FormStructure from './fatboys/form_structure';

export default FormStructure;